export const ADMIN_NAME = {
  firstName: 'Администратор',
  lastName: ' ',
};
